import { useState } from "react";

import { Modal } from "antd";
import { Trans } from "react-i18next";

import UploadImage from "@components/UploadImage";
import { useAppDispatch } from "@hooks/redux";
import { updateSubmitLoading } from "@store/globalSlice";
import { CommonButton } from "@components/CommonButton";

import DeviceModal from "./DeviceModal";

export default () => {
  const [trialModal, setTrialModal] = useState(false);
  const [deviralModal, setDeviralModal] = useState(false);
  const [phoneInfo, setPhoneInfo] = useState<{ phone: string; prefix: string } | null>(null);
  const dispatch = useAppDispatch();
  const handleCloseTrialModal = () => {
    setTrialModal(false);
    dispatch(updateSubmitLoading(false));
  };

  const tipModal = (
    <div>
      {trialModal && (
        <Modal
          className="!w-[412px]"
          footer={false}
          centered
          onCancel={() => handleCloseTrialModal()}
          open={trialModal}
        >
          <div className="flex flex-col items-center justify-center !w-[412px] py-[16px] relative">
            <UploadImage name="806e179f.png" className="h-[71px] absolute top-0 left-0 right-0"></UploadImage>
            <UploadImage name="99a37b4b.webp" className="w-[64px] h-[48px]"></UploadImage>
            <div className="mt-[8px] mb-[12px] px-[44px] flex flex-col items-center">
              <div className="text-left leading-[24px]  ">
                <Trans>
                  Current device has already been logged in with another trial account, please login with previous trail
                  account or a member account
                </Trans>
              </div>
            </div>
            <CommonButton className="px-[24px]  min-w-[133px] h-[34px]" type="primary" onClick={handleCloseTrialModal}>
              <Trans>Got It</Trans>
            </CommonButton>
          </div>
        </Modal>
      )}
      {deviralModal && (
        <DeviceModal
          open={deviralModal}
          onOk={() => {
            setDeviralModal(false);
            dispatch(updateSubmitLoading(false));
          }}
          phoneInfo={phoneInfo!}
        ></DeviceModal>
      )}
    </div>
  );

  const showTrialModal = () => {
    setTrialModal(true);
  };

  const showDeviceMdoal = (formPhoneInfo: any) => {
    setDeviralModal(true);
    setPhoneInfo(formPhoneInfo);
  };

  return { tipModal, showTrialModal, showDeviceMdoal };
};
